export default __webpack_public_path__ + "src/assets/0674834cc892ad12f08a.jpg";